var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"comics-bg"}),_c('div',{staticClass:"comics-hero"},[_c('Navbar'),_c('div',{staticClass:"container"},[_c('Comics')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }